/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-param-reassign */
// eslint-disable-next-line import/no-extraneous-dependencies
import React, { useEffect, useState } from 'react';
import { api } from '@cashew/utils';
import Input from '@cashew/input';
import './index.scss';
import moment from 'moment';
import Button from '@cashew/button';
import { useEnterListener } from '@cashew/hooks';
import ExportModal from './ExportModal';
import SelectComponent from '../../../components/SelectComponent';

const numericInput = /^[0-9]+$/;

export default ({
  setLoading,
  useSelector,
  setRecords,
  setList,
  pageSize,
  pageNumber,
  setPageNumber,
  type,
  records,
  history,
  dispatch,
}: any) => {
  const { token, selectedStore } = useSelector((state: any) => state.user);
  const [searchId, setSearchId] = useState('');
  const [searchBy, setSearchBy] = useState<string>('orderId');
  const [dateFrom, setDateFrom] = useState(
    moment().subtract(2, 'years').format('YYYY-MM-DD')
  );
  const [dateTo, setDateTo] = useState(moment().format('YYYY-MM-DD'));
  const [filterStatus, setFilterStatus] = useState('COMPLETED');
  const [dateToError, setDateToError] = useState('');
  const [dateFromError, setDateFromError] = useState('');
  const [filterParams, setFilterParams] = useState();
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [enterBtn, setEnterBtn] = useState(false);
  const searchByData = [
    {
      key: 'orderId',
      value: 'Order ID',
    },
    {
      key: 'refundId',
      value: 'Refund ID',
    },
    {
      key: 'reference',
      value: 'Merchant order code',
    },
  ];

  const statusFilterData = [
    { key: 'COMPLETED', value: 'Completed' },
    { key: 'REJECTED', value: 'Rejected' },
    { key: 'PROCESSED', value: 'Processing' },
    { key: 'PENDING_APPROVAL', value: 'Pending approval' },
  ];

  const getOrdersApi = (resetPageNumber = true) => {
    setLoading(true);

    if (resetPageNumber && pageNumber !== 0) {
      setPageNumber(0);
      return;
    }

    const params: any = {
      page: pageNumber,
      size: pageSize,
      status: filterStatus,
      dateFrom,
      dateTo,
      storeId: selectedStore > 0 ? selectedStore : null,
    };
    if (searchId && searchBy) {
      params[searchBy] = searchId.trim();
    }
    setFilterParams(params);
    api
      .get({
        endpoint: 'refunds',
        headers: {
          Authorization: token,
        },
        params,
      })
      .then((resp) => {
        setLoading(false);
        setList(
          resp.data.map((item: any) => {
            item.id = item.refundId;
            item.status = item.refundStatus;
            item.date = item.createdAt;
            item.totalAmount =
              item.refundAmount + (item.purchaseFeeRefundAmount || 0);
            item.merchantOrderCode = item.orderReference;
            return item;
          })
        );
        setRecords(resp.totalCount);
      })
      .catch((resp) => {
        api.errorHandler({
          resp,
          history,
        });
      })
      .finally(() => setLoading(false));
  };

  useEnterListener(() => setEnterBtn((prev) => !prev));

  useEffect(() => {
    getOrdersApi();
  }, [filterStatus, dateFrom, dateTo, enterBtn, selectedStore]);

  useEffect(() => {
    setSearchId('');
  }, [searchBy]);

  useEffect(() => {
    getOrdersApi(false);
  }, [pageNumber, pageSize]);

  const getExcelReport = () => {
    api
      .get({
        endpoint: 'refunds/excel',
        responseType: 'blob',
        params: filterParams,
        headers: {
          Authorization: token,
        },
      })
      .then((response) => {
        const [firstDate, secondDate] = new Date()
          .toLocaleString('no-nb')
          .split(',');
        const name = [
          ...firstDate.split('/'),
          ...secondDate.trim().split(':'),
        ].join('-');
        const xhr = new XMLHttpRequest();
        xhr.responseType = 'blob';
        const blob = response;
        const a = window.document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = `Refunds_report_${name}.xlsx`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      })
      .catch((resp) => {
        api.errorHandler({
          resp,
          history,
        });
      });
  };

  return (
    <>
      <div className="filters">
        <div className="filter-group">
          <div className="filter-input">
            <SelectComponent
              label="Search by"
              data={searchByData}
              selected={searchBy}
              onSelect={setSearchBy}
            />
          </div>
          <div className="filter-input">
            <Input
              name="orderId"
              value={searchId}
              maxLength={searchBy === 'orderId' ? 14 : 100}
              type="text"
              onChange={(e: any) => {
                const searchValue = e.target.value;
                if (searchBy === 'refundId' || searchBy === 'orderId') {
                  if (searchValue.match(numericInput) || searchValue === '') {
                    setSearchId(searchValue);
                  }
                } else {
                  setSearchId(searchValue);
                }
              }}
            />
          </div>
          <div className="filter-input">
            <button
              type="button"
              className="btn blue"
              onClick={() => {
                getOrdersApi();
              }}
            >
              Search
            </button>
          </div>
        </div>
        <div className="filter-group">
          <div className="filter-input">
            <label>From</label>
            <Input
              name="dateFrom"
              value={moment(dateFrom).format('YYYY-MM-DD')}
              error={dateFromError ? ' ' : ''}
              type="date"
              onChange={(e: any) => {
                setDateFrom(e.currentTarget.value);
                setDateToError('');

                if (moment(e.currentTarget.value).isAfter(dateTo) && dateTo) {
                  setDateFromError(' should be less than To date');
                } else {
                  setDateFromError('');
                }
              }}
            />
            <span className="error-message">{dateFromError}</span>
          </div>

          <div className="filter-input">
            <span>To</span>
            <Input
              name="dateTo"
              value={moment(dateTo).format('YYYY-MM-DD')}
              type="date"
              error={dateToError ? ' ' : ''}
              onChange={(e: any) => {
                setDateTo(e.currentTarget.value);
                setDateFromError('');
                if (
                  moment(e.currentTarget.value).isBefore(dateFrom) &&
                  dateFrom
                ) {
                  setDateToError(' should be greater than From date');
                } else {
                  setDateToError('');
                }
              }}
            />
            <span className="error-message">{dateToError}</span>
          </div>
        </div>
        <div className="filter-group">
          <div className="filter-input">
            <SelectComponent
              label="Status"
              data={statusFilterData}
              selected={filterStatus}
              onSelect={setFilterStatus}
            />
          </div>
          {type === 'cashew' && (
            <div className="filter-input">
              <Button
                extraClass={records ? 'btn blue' : ''}
                disabled={!records}
                onClick={() => setShowCancelModal(true)}
              >
                Export to Excel
              </Button>
            </div>
          )}
        </div>
      </div>
      {type === 'cashew' && (
        <ExportModal
          showConfirmModal={showCancelModal}
          setShowConfirmModal={setShowCancelModal}
          token={token}
          history={history}
          dispatch={dispatch}
          getExcelReport={getExcelReport}
          records={records}
        />
      )}
    </>
  );
};
